import request from '@/utils/request'

//展示帖子列表
export function postList(data) {
	return request({
		url: '/forum/tForumTopicmainDO/getPaper',
		method: 'get',
		params: data
	})
}
//修改帖子状态
export function updatePost(data) {
	return request({
		url: '/forum/tForumTopicmainDO/updateStatus',
		method: 'put',
		data
	})
}
//查看问题列表
export function questionList(data) {
	return request({
		url: '/forum/tForumTopicmainDO/getQuestionPaper',
		method: 'get',
		params: data
	})
}
//回复问题
export function answerquestion(data) {
	return request({
		url: '/forum/tForumTopicmainDO/answerquestion',
		method: 'put',
		data
	})
}
